import { signInWithPopup, signOut } from "firebase/auth";
import { auth, googleProvider } from "../firebaseConfig";
import { useAuth } from "../context/AuthContext";
import { FaGoogle, FaSignOutAlt, FaSpinner } from "react-icons/fa";
import { useState } from "react";

const Login = () => {
  const { user, setUser, loading } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    if (isLoading) return;
    setIsLoading(true);
    
    try {
      console.log("[Login] Abriendo popup de Google...");
      const result = await signInWithPopup(auth, googleProvider);
      console.log("[Login] Login exitoso:", result.user.email);
      setUser(result.user);
    } catch (error) {
      console.error("[Login] Error:", error.code);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      await signOut(auth);
      setUser(null);
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const showLoading = isLoading || loading;

  return user ? (
    <button
      className="btn-login"
      onClick={handleLogout}
      title="Cerrar sesión"
      disabled={showLoading}
    >
      {showLoading ? <FaSpinner className="spinning" /> : <FaSignOutAlt />}
      <span>{showLoading ? '...' : 'Salir'}</span>
    </button>
  ) : (
    <button
      className="btn-login"
      onClick={handleLogin}
      title="Iniciar sesión con Google"
      disabled={showLoading}
    >
      {showLoading ? <FaSpinner className="spinning" /> : <FaGoogle />}
      <span>{showLoading ? '...' : 'Iniciar'}</span>
    </button>
  );
};

export default Login;
